import Layout from "../../Internal/Layout.vue";
import Base from "./Base.vue";

const CarteiraMovimentacaoRoutes = {
  component: Layout,
  children: [
    {
      name: "carteiraHome",
      path: "/",
      component: Base,
      children: [
        {
          path: '/carteira',
          component: Base,
          name: 'carteira',
          meta: {
            requiresAuth: true,
            requiresBasic: false,
            requiresPattern: true,
            requiresSenior: true,
            requiresExpert: true,
            requiresProfessional: true,
          }
        }
      ],
      meta: {
        requiresAuth: true,
        requiresBasic: false,
        requiresPattern: true,
        requiresSenior: true,
        requiresExpert: true,
        requiresProfessional: true,
      },
    },
  ],
};

export default CarteiraMovimentacaoRoutes;
